//import 'array-from-polyfill'
import 'airbnb-js-shims/target/es2015'
import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import AppContainer from './containers/AppContainer'
import configureStore from './store/configureStore'
import { Provider } from 'react-redux'
import createPlugin from 'bugsnag-react'
import { bugsnagClient } from './constants/AppConstants'
import { unregister } from './registerServiceWorker'
import history from './components/history'
import './styles/App.css'

unregister()
// wrap your entire app tree in the ErrorTracker provided
const ErrorTracker = bugsnagClient.use(createPlugin(React))

ReactDOM.render(
  <ErrorTracker>
    <Provider store={configureStore}>
      <Router history={history}>
        <AppContainer />
      </Router>
    </Provider>
  </ErrorTracker>,
  document.getElementById('root')
)

if (module.hot) {
  module.hot.accept('./containers/AppContainer', () => {
    ReactDOM.render(
      <Provider store={configureStore}>
        <Router history={history}>
          <AppContainer />
        </Router>
      </Provider>,
      document.getElementById('root')
    )
  })
}



// WEBPACK FOOTER //
// ./src/index.js